import { render, staticRenderFns } from "./BatchModifyPage.vue?vue&type=template&id=d0995f8c&scoped=true"
import script from "./BatchModifyPage.vue?vue&type=script&lang=js"
export * from "./BatchModifyPage.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyPage.vue?vue&type=style&index=0&id=d0995f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0995f8c",
  null
  
)

export default component.exports